import React from "react";
import { useHiddenGesture } from "./HiddenGestionaleModal";

/**
 * Scritta "SCONTRINO" sopra il display prezzi/tastierino della cassa.
 * Appare come una semplice etichetta di testo (nessun aspetto da pulsante).
 * Gesto nascosto per il Movimento Gestionale:
 *  - touch: pressione prolungata 2,5 s
 *  - PC/mouse: doppio click
 * Emette l'evento 'velta-gestionale-open' (gestito dal controller del POS).
 */
export default function ScontrinoGestureLabel({ className = "" }) {
  const handlers = useHiddenGesture(() => window.dispatchEvent(new CustomEvent("velta-gestionale-open")));
  return (
    <div
      data-testid="scontrino-gesture-label"
      className={`text-[10px] font-mono uppercase tracking-[0.3em] text-velta-mute select-none cursor-default ${className}`}
      {...handlers}
    >
      Scontrino
    </div>
  );
}
